import React, { useEffect, useState } from 'react';
import { Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ArrowDownward } from '@mui/icons-material';
import { useStores } from '../../../stores';
import {
  BasicAccordion,
  Chip,
  DottedText,
  ExternalLink,
  NoDataVisual,
  Table,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import careQualityMessages from '../../../core-utils/messages/careQualityMessages';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  CARE_QUALITY,
  CARE_QUALITY_INTERNAL,
} from '../../../core-utils/routes';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
// import { getInfoIcon } from '../../../core-utils/helper-utils/infoIconHelper';
import {
  CareQualityMeasures,
  getCareQualityDistributions,
} from '../../../core-utils/helper-utils/careQualityHelper';
import Loader from '../../molecules/Loader';
import { scrollBarStyles } from '../../../core-utils/messages/CommonConstants';
interface CareGapsProps {
  // allDistributions: any;
  // isAllDataAvaialble: boolean;
  incurredStartDate: any;
  incurredEndDate: any;
  paidStartDate: any;
  paidEndDate: any;
  isPlanDatesFetched: any;
  aggregationParameter: any;
}

const CareGaps: React.FC<CareGapsProps> = ({
  // allDistributions,
  // isAllDataAvaialble,
  incurredStartDate,
  incurredEndDate,
  paidStartDate,
  paidEndDate,
  aggregationParameter,
}) => {
  const navigate = useNavigate();
  const careQualityStore = useStores().careQualityStore;
  const [mainLoader] = useState<any>(<Loader height="400px" />);
  const employerGroupStore = useStores().employerGroupStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const [loading, setLoading] = useState(true);

  const [isAllDataAvaialble, setIsAllDataAvailable] = useState<boolean>(false);
  const [allDistributions, setAllDistributions] = useState<
    CareQualityMeasures[]
  >([]);
  const cardMessages = careQualityMessages.CARE_QUALITY_PAGE.CARDS;
  const setAllDistributionsFunction = (data: any) => {
    // const updatedData = data.distribution.filter((temp: any) => {
    //   return cardMessages.EXPERIENCE_FILTER.includes(temp.subMeasure);
    // });
    // setAllDistributions(updatedData);
    setAllDistributions(data.distribution);
    setLoading(false);
  };
  const fetchCareQualityDistributions = async () => {
    try {
      await getCareQualityDistributions(
        {
          startDate:
            aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
          endDate:
            aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
        setAllDistributionsFunction,
        '',
        setIsAllDataAvailable,
      );
    } catch (error) {
      throw error;
    } finally {
      setLoading(false); // ✅ ensure loader stops even on error
    }
  };

  useEffect(() => {
    fetchCareQualityDistributions();
  }, []);

  const CareQualityCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
      tableHeader: {
        height: '48px',
        backgroundColor: patientAccessTheme.palette.grey[100],
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '20px',
        },
        textAlign: 'left',
      },
      tableRow: {
        height: '56px',
        padding: '0px',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '38px',
        },
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
        maxWidth: 365,
      },
      headerText: {
        fontSize: '12px',
        fontHeight: '12px',
        fontWeight: 500,
        color: patientAccessTheme.palette.text.highemphasis,
      },
      queryIconGrid: {
        padding: '10px 0px 10px 22px',
      },
      queryDataOverallGrid: {
        margin: '0px 0px 20px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      tooltipCohort: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: {
        marginTop: '-20px',
        marginLeft: '-20px',
      },
      mainContainer: {
        marginTop: '10px',
        height: '500px',
        overflowY: 'auto',
        paddingRight: '10px',
        ...scrollBarStyles,
      },
    });

    const arrowIconStyle = {
      height: '20px',
      width: '20px',
      color: patientAccessTheme.palette.success.greenbg,
      marginBottom: '0px',
    };

    const { classes } = useStyles();



    const measuresColumns = [
      {
        id: 'individualMeasure',
        accessorKey: 'individualMeasure',
        header: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              minWidth: '350px',
            }}
          >
            <Typography className={classes.headerText}>
              {'Care Gap Measure'}
            </Typography>
            <ExternalLink
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(CARE_QUALITY)}
            />
          </div>
        ),
        footer: 'MEASURES',
        sticky: 'left',
        size: 350,
        cell: ({ getValue, row }: any) => {
          const value = getValue();
          const guideLinks: Record<string, string> = cardMessages.GUIDE_LINK;
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: '20px',
                paddingLeft: '20px',
              }}
            >
              <div
                onClick={() => {
                  if (
                    row?.original?.eligibleCount !== undefined &&
                    row?.original?.eligibleCount === 0
                  ) {
                    return;
                  }

                  const pathDetails: any[] = [];
                  pathDetails.push([
                    'text',
                    'Care Gaps',
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => navigate(CARE_QUALITY),
                  ]);
                  pathDetails.push([
                    'text',
                    row?.original?.individualMeasure,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ]);
                  careQualityStore.setPathDetails(pathDetails);
                  
                  employerGroupStore.setSelectedDuration(
                    aggregationParameter === 'paid'
                      ? paidStartDate
                      : incurredStartDate,
                    aggregationParameter === 'paid'
                      ? paidEndDate
                      : incurredEndDate,
                  );

                  careQualityStore.setsubMeasure(
                    row?.original?.subMeasure ||
                      toJS(
                        careQualityStore.careQualityMeasuresSubMeasure.get(
                          row?.original?.individualMeasure,
                        ),
                      ) ||
                      '',
                  );
                  careQualityStore.setcurrentMeasure(
                    row?.original?.individualMeasure,
                  );
                  careQualityStore.setRuleId(row?.original?.ruleId);
                  navigate(CARE_QUALITY_INTERNAL);
                }}
              >
                <DottedText
                  text={value}
                  truncateText={true}
                  truncateWidth={
                    value === 'Breast Cancer Screening' ? '166px' : '300px'
                  }
                />
              </div>
              {guideLinks[value] && (
                <div
                  style={{ paddingLeft: '10px' }}
                  onClick={() => window.open(guideLinks[value], '_blank')}
                >
                  <DottedText text={'(Guide)'} />
                </div>
              )}
              {row?.original?.inverseMeasureFlag &&
                row?.original?.inverseMeasureFlag === 'Yes' ? (
                <Tooltip
                  title={
                    'INVERSE MEASURE - A lower calculated performance rate for this measure indicates better clinical care or control. The Non-Compliant numerator option for this measure is the representation of better clinical quality or control.'
                  }
                  classes={{ tooltip: classes.tooltip }}
                  arrow
                >
                  <ArrowDownward style={arrowIconStyle} />
                </Tooltip>
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        id: 'eligibleCount',
        accessorKey: 'eligibleCount',
        header: (
          <Typography className={classes.headerText} style={{ minWidth: '125px' }}>
            {'Eligible'}
          </Typography>
        ),
        footer: 'Eligible Members',
        sticky: 'left',
        cellType: 'none',
        icon: 'none',
        size: 125,
      },
      {
        id: 'measureMetCount',
        accessorKey: 'measureMetCount',
        header: (
          <Typography className={classes.headerText} style={{ minWidth: '125px' }}>
            {'Compliant'}
          </Typography>
        ),
        footer: 'Met Members',
        size: 125,
      },
      {
        id: 'measureNotMetCount',
        accessorKey: 'measureNotMetCount',
        header: (
          <Typography className={classes.headerText} style={{ minWidth: '125px' }}>
            {'Non-Compliant'}
          </Typography>
        ),
        footer: 'Unmet Members',
        cellType: 'TextWithIcon',
        icon: 'info',
        size: 125,
      },
      {
        id: 'measureNotEnoughDataCount',
        accessorKey: 'measureNotEnoughDataCount',
        header: (
          <Typography className={classes.headerText} style={{ minWidth: '125px' }}>
            {'Not Enough Data'}
          </Typography>
        ),
        footer: 'Not Enough Data Members',
        cellType: 'TextWithIcon',
        icon: 'info',
        size: 125,
      },
    ];

    const getChipComponent = (
      chipType: 'Needs Intervention' | 'Good' | 'Average' | 'NA',
      label?: string | React.JSX.Element,
    ) => {
      switch (chipType) {
        case 'Needs Intervention':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.AIQChips?.textColor1}
                >
                  {label ?? 'Needs Intervention'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.AIQChips?.background1}
              border="0.3px solid rgba(226, 84, 84, 0.5)"
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );
        case 'Good':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.AIQChips?.textColor2}
                >
                  {label ?? 'Good'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.AIQChips?.background2}
              border="0.3px solid rgba(0, 130, 114, 0.5)"
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );

        case 'Average':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.primary[500]}
                >
                  {label ?? 'Average'}
                </Typography>
              }
              backgroundColor={
                patientAccessTheme.palette.AIQChips?.background15
              }
              border={'0.3px solid' + patientAccessTheme.palette.primary[500]}
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );

        default:
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.grey[900]}
                >
                  {label ?? 'NA'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.grey[300]}
              border={'0.3px solid' + patientAccessTheme.palette.grey[900]}
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );
      }
    };

    const checkChipForSubmeasure = (subMeasure: any) => {
      for (const value of subMeasure?.individualMeasures) {
        if (value?.eligibleCount > 0) {
          return true;
        }
      }
      return false;
    };

    return isAllDataAvaialble ? (
      <Grid>
        <Grid className={classes.mainContainer}>
          {allDistributions?.map((measure: any, index: number) => {
            return (
              <Grid key={index} style={{ marginBottom: '20px', width: '100%' }}>
                <BasicAccordion
                  title={
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Typography>{measure?.subMeasure}</Typography>
                      <div
                        style={{
                          right: '16px',
                          position: 'absolute',
                        }}
                      >
                        {checkChipForSubmeasure(measure)
                          ? getChipComponent(measure?.rank)
                          : getChipComponent('NA')}
                      </div>
                    </div>
                  }
                  height="60px"
                  content={
                    <div style={{ width: '100%' }}>
                      <Table
                        classNameForTableHeaderRowTop={classes.tableHeader}
                        classNameForTableDataRow={classes.tableRow}
                        classNameForTableHeader={classes.tableHeader}
                        columns={measuresColumns}
                        data={measure?.individualMeasures}
                        onHoverRowData={() => { }}
                        controlledPageIndex={0}
                        isManualPagination={true}
                        tableWidth="100%"
                      />
                    </div>
                  }
                  accordionSummaryStyles={{
                    padding: '0px 0px 0px 16px',
                  }}
                  accordionDetailsStyles={{
                    padding: '0px 0px 18px 3px',
                    overflowX: 'scroll',
                    ...scrollBarStyles,
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    ) : (
      <NoDataVisual content="Historical Claims Data Not Available to capture Care Gaps" />
    );
  };

  return loading ? (
    mainLoader
  ) : (
    <Grid>
      <CareQualityCards />
    </Grid>
  );
};
export default CareGaps;
